function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43 30a14.902 17.662 0 01-14.902 17.662A14.902 17.662 0 0113.196 30a14.902 17.662 0 0114.902-17.662A14.902 17.662 0 0143 30z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.117 30l4.99 8.644h9.98L38.079 30l-4.99-8.643h-9.98z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.078 30H43m-24.883 0h-4.922m19.87-8.831l3.312-5.52m-13.27 5.708l-3.289-5.707m3.312 23.181l-3.312 5.52m13.247-5.52l3.312 5.52"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.113 12.446a4.967 4.967 0 116-.023m7.989 5.409s4.331.025 7.21.025c4.268 0 7.895 3.081 7.895 4.91s-3.375-.641-7.643-.641c-1.797 0-3.418.145-4.724.18m-25.165-4.474s-4.331.025-7.21.025c-4.268 0-7.895 3.081-7.895 4.91s3.375-.641 7.643-.641c1.797 0 3.418.145 4.724.18m7.824 23.986a14.93 14.93 0 01-.838 2.474c-1.464 3.353-3.782 5.576-5.179 4.967-1.397-.61-1.343-3.822.12-7.175.614-1.405 1.377-2.613 2.16-3.496m16.576 3.23c.19.79.469 1.627.838 2.474 1.464 3.353 3.782 5.576 5.179 4.967 1.397-.61 1.343-3.822-.12-7.175-.614-1.405-1.377-2.613-2.16-3.496",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}));

var SvgSeaturtle = function SvgSeaturtle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSeaturtle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Sea turtle.b46f1ce4.svg";
export { ForwardRef as ReactComponent };